import { SNAPSHOT_DRILL_PILLAR, splitSnapshotFindings, watchedBehavioursFor, } from "@healthos/shared";
/** How many findings Heartbeat has noticed per behaviour, for the count Snapshot states beside each row. */
/** How many of these Heartbeat is carrying for each behaviour. */
export function heartbeatCarrying(findings, watches = watchedBehavioursFor(false)) {
    const watched = new Set(watches);
    const out = new Map();
    for (const f of splitSnapshotFindings(findings).improve) {
        const behaviour = SNAPSHOT_DRILL_PILLAR[f.drill];
        // A pillar with no arm is not something Heartbeat is carrying, so it is not
        // counted. Gating only the sentence left the count quotable elsewhere.
        if (behaviour && watched.has(behaviour)) {
            out.set(behaviour, (out.get(behaviour) ?? 0) + 1);
        }
    }
    return out;
}
/** What a row of that count says, or null when nothing here bears on it. */
export function heartbeatCarryingSay(count) {
    if (count <= 0)
        return null;
    return count === 1
        ? "Heartbeat is paying attention to this"
        : `Heartbeat is paying attention to ${count} readings here`;
}
//# sourceMappingURL=heartbeat-watchlist.js.map